module.exports = __webpack_public_path__ + "static/img/1_1_3_2.a7c9e8fe.jpg";